export default __webpack_public_path__ + "static/media/Octicons-mark-github.50aeb19a.svg";